import { radius, width } from './border-tokens';

const borders = {
	radius,
	width,
};

export default borders;
export { borders, radius, width };
